import { render, staticRenderFns } from "./ClientsPaymentTable.vue?vue&type=template&id=51116797&scoped=true&"
import script from "./ClientsPaymentTable.vue?vue&type=script&lang=js&"
export * from "./ClientsPaymentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51116797",
  null
  
)

export default component.exports